import { forwardRef } from 'react'
import { StyledText } from './styles'
import { TextProps } from './props'

/**
 * Text component used to display text
 * @param {string} color - The color of the text
 * @param {ReactElement} children - The text to display
 * @param {boolean} bold - Whether the text should be bold
 * @param {boolean} italic - Whether the text should be italic
 * @param {string} size - The size of the text
 * @param {string} fontWeight - The weight of the text
 * @param {boolean} ellipsis - Whether the text should be truncated with an ellipsis
 *
 * @example
 * <Text size="large" bold>
 *   Some text
 * </Text>
 */
const Text = forwardRef<HTMLSpanElement, TextProps>(
    ({ css, color, ...props }, ref) => (
        <StyledText
            {...props}
            css={{
                ...css,
                ...(color && {
                    color: `$${color}`,
                }),
            }}
            ref={ref}
        />
    )
)

Text.displayName = 'Text'

export default Text

export { StyledText }
